import 'keen-slider/keen-slider.min.css';
import './slider-scroller.scss';

import KeenSlider from 'keen-slider';

class SliderScroller {
    constructor(target, options) {
        this.classes = {
            item: 'slider__item',
            keenSlider: 'keen-slider',
            active: 'is-active',
            visible: 'is-visible',
            enabled: 'is-enabled',
            disabled: 'is-disabled',
            open: 'is-open',
        };

        if (!target) {
            return false;
        }

        this.element                         = $(target);
        this.keenSlider                      = this.element.find(`.${this.classes.keenSlider}`);
        this.sliderItem                      = this.element.find(`.${this.classes.item}`);
        this.slidesCount                     = this.sliderItem.length;
        this.touchTimeout                    = null;
        this.position                        = null;
        this.wheelActive                     = null;
        this.singleSlideTimingInMilliseconds = 20000;
        this.isTouchDevice                   = ('ontouchstart' in document.documentElement);
        this.currentPlayingElement           = this.element.find('.slider-currently-playing__song');

        this.sliderSettings = {
            disabled: false,
            loop: true,
            // renderMode: 'performance',
            drag: false,
            mode: 'free',
            selector: `.${this.classes.item}`,
            slides: {
                perView: 'auto',
                spacing: 16,
            },
            // breakpoints: {
            //     '(max-width: 1024px)': {
            //         slides: {
            //             perView: 'auto',
            //             spacing: 32,
            //         },
            //     },
            //     '(max-width: 767px)': {
            //         slides: {
            //             perView: 'auto',
            //             spacing: 24,
            //         },
            //     },
            // },
        };

        if (options) {
            this.sliderSettings = { ...this.sliderSettings, ...options };
        }

        const animation = { duration: this.sliderItem.length * this.singleSlideTimingInMilliseconds, easing: (timing) => timing };

        this.sliderEvents = [
            (slider) => {
                slider.on('created', () => {
                    slider.moveToIdx(this.slidesCount, true, animation);

                    this.element.addClass(this.classes.visible);
                });

                slider.on('updated', () => {
                    setTimeout(() => {
                        slider.moveToIdx(slider.track.details.abs + this.slidesCount, true, animation);
                    }, 30);
                });

                slider.on('animationEnded', () => {
                    slider.moveToIdx(slider.track.details.abs + this.slidesCount, true, animation);
                });
            },
        ];

        this.init();

        this.element[0].sliderScrollerInstance = this;

        // return this.slider;
    }

    init() {
        this.slider = new KeenSlider(this.keenSlider.get(0), this.sliderSettings, this.sliderEvents);
    }

    updateSlides(data) {
        let newText = data.currentArtist;

        if (this.slider) {
            this.slider.destroy();
        }

        if (data.currentSong) {
            newText += ' - ' + data.currentSong;
        }

        this.currentPlayingElement.html(newText);

        this.init();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.js-slider-scroller');

    elements.forEach((element) => new SliderScroller(element));
});
